'use strict';

exports.__esModule = true;
var indentRe = /^((\t|  )+)/mg;
var tabRe = /\t/g;

var normalizeCode = function normalizeCode(code) {
  return code.replace(indentRe, function (_, indentation) {
    return indentation.replace(tabRe, '  ');
  });
};

exports.default = normalizeCode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-live/lib/utils/normalizeCode.js
// module id = 1049
// module chunks = 35783957827783